import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudioUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint0_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M194.95 121.43c-1.25-27.97-24.7-50.27-53.46-50.27-29.56 0-53.51 23.55-53.51 52.6 0 31.29 27.66 55.81 59.6 52.26l14.29 14.92v-18.52a52.6 52.6 0 0 0 33.07-50.99"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint1_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.8 163.15a7 7 0 0 0 3.05.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint2_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m143.93 142.2-6.51-2.23-3.34-27.23-5.11-.65-27.11 7.5a4.4 4.4 0 0 0-3.23 4.77l3.75 28.37 15.55 7.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint3_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m156.57 146.55-5.53-1.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint4_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m143.73 157.53 13.44-5.69a4.5 4.5 0 0 0 2.6-3.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint5_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M171.05 115.42s2.04 1.36 5.22-1.78l1.77 8.95a32 32 0 0 1 8.24-7.67l-3.46-6.82s-6.92-13.56-16.86-10.07c0 0-.68 15.1 5.09 17.39"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M175.18 84.22s-6.26 0-8.46 3.87-5.92.84-8.8 3.04c-2.9 2.21-1.43 10.5 8.07 10.7-.1-2.21-.03-3.8-.03-3.8s4.1-.98 5.31.91c1.22 1.9 1.82 7.6 2.28 7.67s.91-3.5 3.04-2.88c2.12.6-.76 4.17-1.3 5.16-.2.39.25 1 .95 1.59 4.02 3.4 7.53.53 7.42-1.64-.11-1.34.15-2.7.75-3.9 1.36-2.43 6.14-20.72-9.23-20.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint6_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M175.18 84.22s-6.26 0-8.46 3.87-5.92.84-8.8 3.04c-2.9 2.21-1.43 10.5 8.07 10.7-.1-2.21-.03-3.8-.03-3.8s4.1-.98 5.31.91c1.22 1.9 1.82 7.6 2.28 7.67s.91-3.5 3.04-2.88c2.12.6-.76 4.17-1.3 5.16-.2.39.25 1 .95 1.59 4.02 3.4 7.53.53 7.42-1.64-.11-1.34.15-2.7.75-3.9 1.36-2.43 6.14-20.72-9.23-20.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M134.08 112.74 104.45 121a4.5 4.5 0 0 0-3.24 4.92l3.42 24.97 32.79-10.93zm-13.8 28.09c-4.96 0-8.98-4.45-8.98-9.93s4.02-9.93 8.98-9.93 8.98 4.45 8.98 9.93-4.02 9.93-8.98 9.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint7_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.63 150.9-3.42-24.97a4.5 4.5 0 0 1 3.24-4.92l29.63-8.27 3.34 27.23z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint8_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m142.88 154.74 15.69-6.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint9_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m138.95 156.36 1.03-.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint10_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m121.17 158.47 2.65 1.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint11_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.63 150.9 10.97 5.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint12_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m142.13 151.4 3.17-1.37-4.46-2.13-11.28 4.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint13_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m136.18 154 3.27-1.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint14_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M129.26 130.9c0 5.48-4.02 9.93-8.98 9.93-4.95 0-8.97-4.45-8.97-9.93s4.02-9.93 8.97-9.93 8.98 4.45 8.98 9.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint15_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M117.92 126.7c1.06-1.12 4.9-2.1 4.39.63a5.4 5.4 0 0 1-2.25 2.74 2 2 0 0 0-.62.54c-.63.98.14 2.6.52 3.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M120.78 136.67a.64.64 0 1 0 0-1.29.64.64 0 0 0 0 1.29"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint16_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M186.6 114.73A31 31 0 0 0 177 124a43 43 0 0 0-6.48 14.41c-2.85 11.29-2.9 23.71-2.59 31.09a52.4 52.4 0 0 0 27.02-48.07c-2.56-2.86-5.85-6.06-8.34-6.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M187.8 136.07A33 33 0 0 0 177 124a40 40 0 0 0-2.5 4.04c3.76 2.62 10.01 8.64 13.83 21.16 3.28-5.8 5.4-12.2 6.25-18.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint17_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M187.8 136.07A33 33 0 0 0 177 124a40 40 0 0 0-2.5 4.04c3.76 2.62 10.01 8.64 13.83 21.16 3.28-5.8 5.4-12.2 6.25-18.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint18_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M164.7 171.17s-14-3.49-16.51-5.27c-2.52-1.79-10.29-11.76-13.02-12.39s-15.74-3.4-16.27-3.14-.52 2.46 1.47 3.2c2 .73 10.23 2.36 10.23 2.36s-13.9-1.21-14.74-.84c-.84.36.2 2.46 1.89 2.88 1.68.42 11.33 1.32 11.33 1.32s-13.01.84-13.17 1.52.95 2.04 2.1 2.2c1.16.15 10.45.16 10.45.16s-7.88 4.35-8.09 4.67c-.2.31.69 1.62 3.57 1.1 2.89-.53 6.93-2.63 8.14-2.52 1.13.1 6.2 8.93 6.72 9.88q4.4.2 8.77-.29l14.3 14.92v-18.51q1.43-.59 2.83-1.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint19_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M145.78 163.63s-3-8.49-3.26-10.48c-.27-2-1.16-4.04-1.9-3.94-.73.1-1.41 2.73-1.1 4.78q.41 2.2 1.3 4.28z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint20_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M169.1 145.45s-8.3-8.32-10.32-9.42-16.16 0-16.16 0l-2.49.04s-.62 2.5 2.49 2.8c3.1.3 8.37-.3 9.98.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint21_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m157.56 140.5-13.63 1.7s.27 1.73 3 2.24c2.73.5 8.3 0 8.3 0s2.02 5.09 7.39 4.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint22_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M140.25 137.46h-1.54s-.38 2.03 2.35 2.9c2.45.78 8.2.86 10.75.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint23_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m157.65 151.6 10.16 10.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint24_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M82.87 25.9C46.33 11.1 5 37.15 5 76.66a53.8 53.8 0 0 0 12.27 34.22l-7.82 19.37 19.37-8.74a57 57 0 0 0 32.52 10.07c31.07 0 56.35-24.55 56.35-54.92-.01-12.28-4.2-24.14-11.81-33.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint25_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m112.91 54.5-32.03 3.46-3.63 49.03 33.97-4.76a53.8 53.8 0 0 0 1.69-47.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "m91.31 105 19.92-2.8a53.6 53.6 0 0 0 6.45-25.64A53 53 0 0 0 91.32 105"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint26_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m91.31 105 19.92-2.8a53.6 53.6 0 0 0 6.45-25.64A53 53 0 0 0 91.32 105"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M111.23 102.2 91.31 105a52 52 0 0 0-3.49 20.15 56 56 0 0 0 23.41-22.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint27_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M111.23 102.2 91.31 105a52 52 0 0 0-3.49 20.15 56 56 0 0 0 23.41-22.95"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "audio-unavailable_svg__path-35-outside-1_4001_7703",
			width: 14.519,
			height: 19.064,
			x: 102.54,
			y: 70.564,
			fill: "#000",
			maskUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M102.54 70.56h14.52v19.07h-14.52z"
			}), /* @__PURE__ */ _jsx("path", { d: "M108.63 87.23s-3.74-.14-3.9-1.95c-.14-1.59 1.92-2.32 3.5-2.68zm-1.22-13.95c.03 0 7.27.34 7.59 4.03s-5.19 4.94-6.77 5.3z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M108.63 87.23s-3.74-.14-3.9-1.95c-.14-1.59 1.92-2.32 3.5-2.68zm-1.22-13.95c.03 0 7.27.34 7.59 4.03s-5.19 4.94-6.77 5.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#audio-unavailable_svg__paint28_linear_4001_7703)",
			d: "m108.63 87.23-.03 1 1.13.04-.1-1.13zm-3.9-1.95-1 .09zm2.68-12 .05-1-1.14-.05.1 1.14zM115 77.3l1-.09zm-6.37 9.92.04-1-.13-.01a9 9 0 0 1-1.54-.25 3 3 0 0 1-1.01-.44c-.22-.16-.26-.27-.26-.34l-1 .1-1 .08c.08.83.57 1.42 1.1 1.79.5.37 1.12.59 1.65.73a10 10 0 0 0 2.1.33h.01zm-3.9-1.95 1-.09c-.02-.24.08-.52.63-.86a7 7 0 0 1 2.08-.75l-.21-.98-.22-.97c-.82.18-1.86.48-2.7 1s-1.7 1.4-1.57 2.74zm3.5-2.68-1 .1.4 4.61 1-.08 1-.1-.4-4.61zm-.82-9.32-.05 1s1.72.08 3.45.6c.87.25 1.68.6 2.27 1.04q.85.65.92 1.48l1-.09 1-.09a4 4 0 0 0-1.71-2.9 9 9 0 0 0-2.91-1.37 19 19 0 0 0-3.92-.67zM115 77.3l-1 .09c.1 1.22-.7 2.16-2.14 2.93-1.4.74-3.05 1.12-3.85 1.3l.22.97.21.98c.8-.17 2.69-.6 4.36-1.49 1.63-.87 3.4-2.4 3.2-4.87zm-6.77 5.3 1-.1-.82-9.32-1 .09-1 .09.82 9.32z",
			mask: "url(#audio-unavailable_svg__path-35-outside-1_4001_7703)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M91 33.97a.8.8 0 0 1-.78-.79V21.84a.78.78 0 0 1 1.56 0v11.35a.8.8 0 0 1-.78.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M91.9 38.6a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint29_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M77.33 43.33h27.34a2.33 2.33 0 0 0 2.02-3.5L93.03 16.17a2.34 2.34 0 0 0-4.05 0L75.31 39.84a2.33 2.33 0 0 0 2.02 3.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint30_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M92.28 33.19v.03a1.28 1.28 0 0 1-2.56-.04V21.82q.04-.5.4-.85a1.3 1.3 0 0 1 1.75 0q.37.34.4.85l.01.03z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint31_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M91 37.2q.27 0 .53.1.2.08.36.21l.1.1a1.4 1.4 0 0 1-1.26 2.36 1.4 1.4 0 0 1-1.03-1.91q.18-.39.52-.63t.78-.23"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint32_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M54.55 139.63v12.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint33_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M60.78 145.85H48.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint34_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.11 57.14v9.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint35_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M167.8 61.83h-9.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint36_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M74.46 9.06v6.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint37_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M77.84 12.43h-6.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint38_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M77.93 155.3a3.05 3.05 0 1 0 0-6.1 3.05 3.05 0 0 0 0 6.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint39_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M133.16 60.19a3.05 3.05 0 1 0 0-6.1 3.05 3.05 0 0 0 0 6.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint40_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M145.78 86.36a3.05 3.05 0 1 0 0-6.1 3.05 3.05 0 0 0 0 6.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M67.24 113.83a.5.5 0 0 0-.48.26.5.5 0 0 0 .05.55q.99 1.21 1.75 2.3l2.13-.65c-2.17-1.79-2.78-2.39-3.45-2.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M49.38 32.44c-1.08-.74-3.82-1.93-4.63-.23-.7 1.47 1.12 2.96-.7 4.74q-.48.39-1 .72c-.5-4.45-6.58-6.11-7.49-2.24-.32 1.4.27 2.95-.58 4.21-.89 1.32-2.38 1.15-3.7 1.7-3.36 1.4-6.56 3.99-6.76 7.61q-.1 2.34.6 4.57a9.66 9.66 0 0 0-5.32 17.35 29 29 0 0 1 8.62-1.82l.9-.64a5.7 5.7 0 0 0 2.32-3.73l1.26-7.93c-1.53-.62-3.4-2.93-2.08-3.74 1.32-.8 2.93 1.18 2.93 1.18s1.52-7.56 5.37-6.96c1.3.2 2.22 1.66 2.84 3.6 1.66.04 3.3-.29 4.82-.96 6.29-2.87 8.87-13.15 2.6-17.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint41_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M49.38 32.44c-1.08-.74-3.82-1.93-4.63-.23-.7 1.47 1.12 2.96-.7 4.74q-.48.39-1 .72c-.5-4.45-6.58-6.11-7.49-2.24-.32 1.4.27 2.95-.58 4.21-.89 1.32-2.38 1.15-3.7 1.7-3.36 1.4-6.56 3.99-6.76 7.61q-.1 2.34.6 4.57a9.66 9.66 0 0 0-5.32 17.35 29 29 0 0 1 8.62-1.82l.9-.64a5.7 5.7 0 0 0 2.32-3.73l1.26-7.93c-1.53-.62-3.4-2.93-2.08-3.74 1.32-.8 2.93 1.18 2.93 1.18s1.52-7.56 5.37-6.96c1.3.2 2.22 1.66 2.84 3.6 1.66.04 3.3-.29 4.82-.96 6.29-2.87 8.87-13.15 2.6-17.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint42_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M33.76 54.19S32.14 52.2 30.83 53c-1.32.82.55 3.12 2.07 3.74l-1.26 7.93a5.7 5.7 0 0 1-2.32 3.73l-.9.64s5 11.45 10.6 11.02c4.6-.35 3.2-8.9 2.04-11.84-.52-1.34-1.39-2.7-1.39-4.4a2.8 2.8 0 0 0 2.92-2.02c.96-2.35.38-13.97-3.47-14.58-3.84-.6-5.36 6.96-5.36 6.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M39.67 63.83c-1.02-.1-2-.44-2.84-1.02 0 0-.79 2.65 3.42 3.55a7 7 0 0 1-.58-2.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint43_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M39.67 63.83c-1.02-.1-2-.44-2.84-1.02 0 0-.79 2.65 3.42 3.55a7 7 0 0 1-.58-2.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint44_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.42 69.05S11.4 69.32 5.6 84.66a56.4 56.4 0 0 0 11.67 26.22l-7.82 19.37 19.37-8.74s4.56 3.4 14.17 7.1c0 0 9.09-2.19 13.19-7.1a2.1 2.1 0 0 1 1.78-.66c.82.14 1.7.7 2.84 2.38 1.72 2.53 2.74 3.84 3.55 3.49s1.17-3.67-3.44-8.32c0 0-.4-.38.4-.18.81.2 5.32 6.84 6.79 6.83s1.41-.81 1.41-1.37c0-.55-5.16-7.13-5.16-7.13s5.31 7.13 6.63 7.24c1.28.1.45-3.5-4.17-9.15-.32-.4.03-1.26 1.18-.52 1.12.7 6.43 5.57 7.3 5.31 1.1-.32-.47-2.96-.72-3.34-1.35-2.04-4.93-4.61-5.97-5.33-.4-.29.02-.13-11.4-2.65 0 0-15.18 7.88-20.87 7.48-5.68-.4-16.61-9.2-14.08-29.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M28.42 69.05c-3.24.18-6.42.9-9.42 2.13 0 0-.09 3.08 5.28 3.1 0 0-2.18 2.04-1.92 3.56.25 1.52 3.74 1.01 5.71-.45 0 0-.24 3.27 2.69 4.36 2.57.95 5.24-.67 5.58-2.33-4.43-2.37-7.92-10.37-7.92-10.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint45_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.42 69.05c-3.24.18-6.42.9-9.42 2.13 0 0-.09 3.08 5.28 3.1 0 0-2.18 2.04-1.92 3.56.25 1.52 3.74 1.01 5.71-.45 0 0-.24 3.27 2.69 4.36 2.57.95 5.24-.67 5.58-2.33-4.43-2.37-7.92-10.37-7.92-10.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint46_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M49.34 72c2.1 1.23 4 2.8 5.6 4.65 5.87 6.76 1.62 20.72 10.93 23s11.8 1.88 11.8 1.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint47_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M50.18 78.25s4.25 6.54.71 23.3a49 49 0 0 1 6.3 6.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint48_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M50.89 101.56s-10.16 4.68-26.79 2.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint49_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M39.35 80.1 40 88.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M40.64 79.49a4.8 4.8 0 0 0 3.72 1.7c2.36-.08 3.2-3.31 1.6-5.6 0 0 3.1.05 3.56-.7.46-.77-2.73-2.89-2.73-2.89h2.55s-4.62-3.3-8-3.3c0 0 2.4 8.6-.7 10.79"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint50_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M40.64 79.49a4.8 4.8 0 0 0 3.72 1.7c2.36-.08 3.2-3.31 1.6-5.6 0 0 3.1.05 3.56-.7.46-.77-2.73-2.89-2.73-2.89h2.55s-4.62-3.3-8-3.3c0 0 2.4 8.6-.7 10.79"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M42.06 85.18a.93.93 0 1 0 0-1.87.93.93 0 0 0 0 1.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint51_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M42.06 85.18a.93.93 0 1 0 0-1.87.93.93 0 0 0 0 1.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint52_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m74 115.28 15.5-4.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint53_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m53.69 123.8 13.37 7.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint54_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m51.52 125.41 11.4 6.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M70.06 111.82a27 27 0 0 1 3.9 3.47l6.6-2a90 90 0 0 1-10.5-1.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint55_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M9.07 96.98a36 36 0 0 0 13.29 1.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#audio-unavailable_svg__paint56_linear_4001_7703)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M51.98 94.83s5-.61 7.52-3.08"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint0_linear_4001_7703",
				x1: 141.482,
				x2: 138.268,
				y1: 173.124,
				y2: 92.945,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint1_linear_4001_7703",
				x1: 125.323,
				x2: 125.317,
				y1: 163.93,
				y2: 163.317,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint2_linear_4001_7703",
				x1: 121.267,
				x2: 120.037,
				y1: 153.128,
				y2: 120.851,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint3_linear_4001_7703",
				x1: 153.804,
				x2: 153.788,
				y1: 146.271,
				y2: 144.997,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint4_linear_4001_7703",
				x1: 151.748,
				x2: 151.635,
				y1: 156.235,
				y2: 150.402,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint5_linear_4001_7703",
				x1: 176.107,
				x2: 175.363,
				y1: 118.852,
				y2: 102.035,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint6_linear_4001_7703",
				x1: 171.386,
				x2: 170.758,
				y1: 107.909,
				y2: 89.271,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint7_linear_4001_7703",
				x1: 119.296,
				x2: 118.332,
				y1: 145.224,
				y2: 119.671,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint8_linear_4001_7703",
				x1: 150.724,
				x2: 150.66,
				y1: 153.776,
				y2: 149.434,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint9_linear_4001_7703",
				x1: 139.463,
				x2: 139.459,
				y1: 156.301,
				y2: 156.015,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint10_linear_4001_7703",
				x1: 122.496,
				x2: 122.483,
				y1: 159.502,
				y2: 158.691,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint11_linear_4001_7703",
				x1: 110.117,
				x2: 110.062,
				y1: 155.176,
				y2: 151.81,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint12_linear_4001_7703",
				x1: 137.427,
				x2: 137.398,
				y1: 151.643,
				y2: 148.698,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint13_linear_4001_7703",
				x1: 137.814,
				x2: 137.799,
				y1: 153.784,
				y2: 152.827,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint14_linear_4001_7703",
				x1: 120.283,
				x2: 119.756,
				y1: 137.875,
				y2: 124.582,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint15_linear_4001_7703",
				x1: 120.137,
				x2: 119.739,
				y1: 132.89,
				y2: 127.15,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint16_linear_4001_7703",
				x1: 181.399,
				x2: 178.763,
				y1: 161.354,
				y2: 124.823,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint17_linear_4001_7703",
				x1: 184.544,
				x2: 183.785,
				y1: 145.455,
				y2: 128.59,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint18_linear_4001_7703",
				x1: 140.131,
				x2: 139.327,
				y1: 184.896,
				y2: 157.708,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint19_linear_4001_7703",
				x1: 142.615,
				x2: 141.832,
				y1: 161.483,
				y2: 151.878,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint20_linear_4001_7703",
				x1: 154.591,
				x2: 154.51,
				y1: 143.973,
				y2: 137.328,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint21_linear_4001_7703",
				x1: 153.273,
				x2: 153.175,
				y1: 147.923,
				y2: 142.071,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint22_linear_4001_7703",
				x1: 145.251,
				x2: 145.226,
				y1: 140.655,
				y2: 138.139,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint23_linear_4001_7703",
				x1: 162.729,
				x2: 162.493,
				y1: 160.13,
				y2: 153.423,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint24_linear_4001_7703",
				x1: 61.343,
				x2: 58.773,
				y1: 115.239,
				y2: 41.652,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint25_linear_4001_7703",
				x1: 97.471,
				x2: 95.839,
				y1: 99.184,
				y2: 64.069,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint26_linear_4001_7703",
				x1: 104.5,
				x2: 103.764,
				y1: 100.765,
				y2: 81.729,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint27_linear_4001_7703",
				x1: 99.518,
				x2: 98.979,
				y1: 121.733,
				y2: 106.367,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint28_linear_4001_7703",
				x1: 110.189,
				x2: 108.944,
				y1: 84.999,
				y2: 75.705,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint29_linear_4001_7703",
				x1: 91,
				x2: 90.398,
				y1: 39.12,
				y2: 20.141,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint30_linear_4001_7703",
				x1: 91,
				x2: 88.681,
				y1: 32.009,
				y2: 24.107,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint31_linear_4001_7703",
				x1: 91,
				x2: 90.957,
				y1: 39.23,
				y2: 38.023,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint32_linear_4001_7703",
				x1: 55.052,
				x2: 51.948,
				y1: 150.226,
				y2: 143.264,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint33_linear_4001_7703",
				x1: 54.552,
				x2: 54.55,
				y1: 146.705,
				y2: 146.035,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint34_linear_4001_7703",
				x1: 163.613,
				x2: 161.716,
				y1: 65.121,
				y2: 59.471,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint35_linear_4001_7703",
				x1: 163.112,
				x2: 163.11,
				y1: 62.678,
				y2: 62.008,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint36_linear_4001_7703",
				x1: 74.965,
				x2: 73.933,
				y1: 14.801,
				y2: 10.529,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint37_linear_4001_7703",
				x1: 74.464,
				x2: 74.461,
				y1: 13.283,
				y2: 12.613,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint38_linear_4001_7703",
				x1: 77.925,
				x2: 77.779,
				y1: 154.398,
				y2: 150.315,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint39_linear_4001_7703",
				x1: 133.16,
				x2: 133.014,
				y1: 59.281,
				y2: 55.197,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint40_linear_4001_7703",
				x1: 145.783,
				x2: 145.637,
				y1: 85.45,
				y2: 81.367,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint41_linear_4001_7703",
				x1: 34.481,
				x2: 33.469,
				y1: 64.987,
				y2: 38.523,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint42_linear_4001_7703",
				x1: 35.706,
				x2: 33.936,
				y1: 75.191,
				y2: 53.285,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint43_linear_4001_7703",
				x1: 38.51,
				x2: 38.423,
				y1: 65.836,
				y2: 63.458,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint44_linear_4001_7703",
				x1: 40.638,
				x2: 39.355,
				y1: 121.149,
				y2: 80.153,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint45_linear_4001_7703",
				x1: 27.669,
				x2: 27.435,
				y1: 80.101,
				y2: 71.402,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint46_linear_4001_7703",
				x1: 63.501,
				x2: 62.761,
				y1: 97.161,
				y2: 77.371,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint47_linear_4001_7703",
				x1: 53.69,
				x2: 50.706,
				y1: 103.676,
				y2: 84.103,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint48_linear_4001_7703",
				x1: 37.495,
				x2: 37.486,
				y1: 104.286,
				y2: 102.136,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint49_linear_4001_7703",
				x1: 39.672,
				x2: 37.354,
				y1: 87.602,
				y2: 82.81,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint50_linear_4001_7703",
				x1: 45.102,
				x2: 44.684,
				y1: 79.327,
				y2: 70.978,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint51_linear_4001_7703",
				x1: 42.059,
				x2: 42.014,
				y1: 84.9,
				y2: 83.648,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint52_linear_4001_7703",
				x1: 81.75,
				x2: 81.715,
				y1: 114.578,
				y2: 111.417,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint53_linear_4001_7703",
				x1: 60.375,
				x2: 60.274,
				y1: 130.188,
				y2: 125.161,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint54_linear_4001_7703",
				x1: 57.222,
				x2: 57.144,
				y1: 130.601,
				y2: 126.517,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint55_linear_4001_7703",
				x1: 15.717,
				x2: 15.714,
				y1: 98.07,
				y2: 97.21,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "audio-unavailable_svg__paint56_linear_4001_7703",
				x1: 55.742,
				x2: 55.712,
				y1: 94.373,
				y2: 92.305,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default SvgAudioUnavailable;
